/**
 * O bloqueio por rede DESTA aba (faixa 28 §4). Ver `redeBloqueada.md`.
 *
 * Aceso por quem vê o 403 `NETWORK_FORBIDDEN` (renovação, interceptor, ack `network_forbidden`, portão na abertura);
 * apagado por quem prova que a rede voltou (renovação 200, access de outra aba, "Tentar de novo"). Só a TRANSIÇÃO
 * avisa. Nunca apaga nada: quem escuta cobre a tela e pausa o socket.
 */

/** A frase do back (`app/exceptions/exceptions.py::RedeProibidaError`). Texto fixo da tela de bloqueio. */
export const TEXTO_REDE_BLOQUEADA = 'Acesso permitido só a partir da rede da empresa.'

type Ouvinte = () => void

let bloqueada = false
const ouvintes = new Set<Ouvinte>()

function avisar(): void {
  for (const ouvir of [...ouvintes]) ouvir()
}

export function bloquear(): void {
  if (bloqueada) return
  bloqueada = true
  avisar()
}

export function liberar(): void {
  if (!bloqueada) return
  bloqueada = false
  avisar()
}

export function estaBloqueada(): boolean {
  return bloqueada
}

/** No formato do `useSyncExternalStore`: o ouvinte lê `estaBloqueada()`. Ouvinte não pode lançar. */
export function ouvirRedeBloqueada(ouvinte: Ouvinte): () => void {
  ouvintes.add(ouvinte)
  return () => {
    ouvintes.delete(ouvinte)
  }
}

/** Só para teste: o módulo sobrevive entre casos do mesmo arquivo. */
export function __resetRedeBloqueada(): void {
  bloqueada = false
  ouvintes.clear()
}
